import { EmployeeDto } from './employee-dto.model';
import { AssetMasterDto } from './asset-master-dto.model';
import { BranchDto } from './branch-dto.model';


export class AssignedAssetDto implements IAssignedAssetDto {
    id!: number;
    employeeId!: number;
    branchId!: number;
    assetId!: number;
    quantity!: number;
    employee!: EmployeeDto;
    asset!: AssetMasterDto;
    branch!: BranchDto;

    constructor(data?: IAssignedAssetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.employeeId = _data["employeeId"];
            this.branchId = _data["branchId"];
            this.assetId = _data["assetId"];
            this.quantity = _data["quantity"];
            this.employee = _data["employee"] ? EmployeeDto.fromJS(_data["employee"]) : <any>undefined;
            this.asset = _data["asset"] ? AssetMasterDto.fromJS(_data["asset"]) : <any>undefined;
            this.branch = _data["branch"] ? BranchDto.fromJS(_data["branch"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AssignedAssetDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssignedAssetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["employeeId"] = this.employeeId;
        data["branchId"] = this.branchId;
        data["assetId"] = this.assetId;
        data["quantity"] = this.quantity;
        data["employee"] = this.employee ? this.employee.toJSON() : <any>undefined;
        data["asset"] = this.asset ? this.asset.toJSON() : <any>undefined;
        data["branch"] = this.branch ? this.branch.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IAssignedAssetDto {
    id: number;
    employeeId: number;
    branchId: number;
    assetId: number;
    quantity: number;
    employee: EmployeeDto;
    asset: AssetMasterDto;
    branch: BranchDto;
}

